import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import HeadingPropTypes from '../definitions/HeadingPropTypes';
import HeadingBlock from './HeadingBlock';


function AccordionContainer({
    heading,
    hasMaxWidth = true,
    className,
    children,
    ...otherProps
}) {
    return (
        <div
            className={classNames('rh-mx-auto', {
                'rh-max-width-800px': hasMaxWidth,
            }, className)}
            {...otherProps}
        >
            <HeadingBlock
                {...heading}
            />

            {children}
        </div>
    );
}

AccordionContainer.propTypes = {
    heading: HeadingPropTypes,
    hasMaxWidth: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.any.isRequired,
};

AccordionContainer.blockKey = 'rh/accordion-container';
AccordionContainer.hasHeading = true;
AccordionContainer.requiresLayoutRow = true;


export default AccordionContainer;
